export default {
  methods: {
    showErrorMessage () {
      this.$store.commit('SET_SNACKBAR', {
        color: 'pink',
        message: 'Oops! Something went wrong!',
        timeout: 3000,
        status: true
      })
    },

    showCustomErrorMessage (message, timeout) {
      this.$store.commit('SET_SNACKBAR', {
        color: 'pink',
        message: message,
        timeout: timeout,
        status: true
      })
    },

    showSuccessMessage (message) {
      this.$store.commit('SET_SNACKBAR', {
        color: 'cyan darken-1',
        message: message,
        timeout: 3000,
        status: true
      })
    },

    showCustomSuccessMessage (message, timeout) {
      this.$store.commit('SET_SNACKBAR', {
        color: 'cyan darken-1',
        message: message,
        timeout: timeout,
        status: true
      })
    }
  }
}
